import { Component } from '@angular/core';

@Component({
  selector: 'vt-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {}
